import React from 'react';

import { CheckCircleIcon, CrossCircleIcon } from '@vlabs/icons';
import i18n from 'i18next';

import './ProgressCell.sass';

const STATUS_OPTIONS = {
  get error() {
    return i18n.t('constants:error');
  },
  get done() {
    return i18n.t('constants:done');
  },
};

function ProgressCell(status) {
  const iconsMap = {
    error: <CrossCircleIcon className="ProgressCell_canceled" />,
    done: <CheckCircleIcon className="ProgressCell_finished" />,
  };

  return (
    <div className="ProgressCell">
      <div title={STATUS_OPTIONS[status]}>
        {iconsMap[status]}
      </div>
    </div>
  );
}

export default ProgressCell;
